import { Alert, Card, Image, Typography } from 'antd';
import type { AiImagePayload } from '../../../types/ai-analysis.types';
export default function AiImageReview({
  payload,
  imageUrl,
}: {
  payload: AiImagePayload;
  imageUrl?: string;
}) {
  return (
    <Card title="Imagem associativa">
      {imageUrl && <Image src={imageUrl} alt={payload.altText} width={360} />}
      <Typography.Title level={5}>Conceito</Typography.Title>
      <Typography.Paragraph>{payload.concept}</Typography.Paragraph>
      <Alert type="info" message="Texto alternativo" description={payload.altText} />
      <Typography.Paragraph type="secondary">{payload.editorialGuidance}</Typography.Paragraph>
    </Card>
  );
}
